import ReactGA from 'react-ga';
import _ from 'lodash';

export const EVENT_CATEGORIES = {
  AUTO_ACCEUIL: 'Auto_Accueil_',
  AUTO_DETAILS: 'Auto_Details_',
  MRH_DETAILS: 'MRH_Details_',
  MRH_ACCUEIL: 'MRH_Accueil_',
  EPARGN_ACCUEIL: 'Epargne_Accueil_',
  EPARGN_DETAILS: 'Epargne_ Details_',
  AMC_ACCUEIL: 'Amc_Accueil_',
  AMC_DETAILS: 'Amc_ Details_',
  LOGIN: 'Login_Connexion',
  LOGIN_CREATION: 'Login_Création de compte',
  RECOVERY_PASSWORD: 'Accès oubliés_Mot de passe oublié_',
  RECOVERY_LOGIN: 'Accès oubliés_identifiant oublié',
  FORGOTTEN_PASSWORD_QUESION_SECRETE:
    'Accès oubliés_Recupérer via Question secrète',
  FORGOTTEN_PASSWORD_EMAIL: 'Accès oubliés_Recupérer via Email',
  FORGOTTEN_NEW_PASSWORD: 'Accès oubliés_Nouveau mot de passe',
  FORGOTTEN_ACCESS_RECOVERY_LOGIN:
    "Accès oubliés_Récupération de l'identifiant",
  AUTH_BY_SMS: 'Login_Authentification par SMS',
  AUTH_BY_EMAIL: 'Login_Authentification par Email',
  LOGIN_CONTRACT: 'Login_Authentification par Contrat',
  LOGIN_PARAMETERS: 'Login_Paramètre de sécurité',
  LEXIQUE: 'Lexique',
  LEGAL_NOTICE: 'Mentions légales',
  FACEBOOK: 'Facebook',
  YOUTUBE: 'Youtube',
  CONTACT_US: 'Contactez-nous',
  NOTIFICATIONS: 'Notifications',
  MY_ACCOUNT: 'Mon compte',
  SETTINGS: 'Paremètres du compte',
  ADD_CONTRACT: 'Ajouter un contrat',
  SERVICES: 'Localiser mes services',
  CONTACTS: 'Contacts utiles',
  OFFRES_CONSEILS: 'Offres et conseils',
  ASI_ACCUEIL: 'asi_Accueil_',
  ASI_DETAILS: 'asi_Details_',
};

export const EVENT_ACTION = {
  CLICK: 'Click',
  LOAD: 'Pageview',
  HOVER: 'Hover',
  ERROR: 'Error',
};

export const init = () => {
  if (!_.isEmpty(process.env.REACT_APP_GA_TRACKING_ID)) {
    ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID as string, {
      debug: process.env.REACT_APP_GA_DEBUG === 'true',
    });
  }
};

export const pageView = () => {
  if (!_.isEmpty(process.env.REACT_APP_GA_TRACKING_ID)) {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
};

export const set = (field: string, value: string) => {
  if (!_.isEmpty(process.env.REACT_APP_GA_TRACKING_ID)) {
    ReactGA.set({ [field]: value });
  }
};

export type GaEvent = {
  action: string;
  label?: string;
  category: string;
};

export const event = (
  category: string,
  action: string,
  label?: string,
  value?: number,
  nonInteraction?: boolean,
) => {
  if (!_.isEmpty(process.env.REACT_APP_GA_TRACKING_ID)) {
    ReactGA.event({
      category,
      action,
      label,
      value,
      nonInteraction,
    });
  }
};

export default { EVENT_CATEGORIES, EVENT_ACTION, init, pageView, set, event };
